import UserThumbnail from '@atom/components/common/UserThumbnail';
import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import { getTaskUserStatusValues } from '@atom/selectors/taskSelectors';
import colors from '@atom/styles/colors';
import { TaskUserStatus } from '@atom/types/task';
import { UserProfile } from '@atom/types/user';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import classes from './userStatusControls.module.css';

interface Props {
  user: UserProfile;
  isLeadAssignee: boolean;
  setIsLeadAssignee: (isLeadAssignee: boolean) => void;
  taskUserStatus: TaskUserStatus;
}

const ModalTitle = ({
  user,
  isLeadAssignee,
  setIsLeadAssignee,
  taskUserStatus,
}: Props) => {
  const [, { Link }] = useNavigation();
  const userName = `${user?.firstName} ${user?.lastName}`;

  const taskUserStatusValues = getTaskUserStatusValues(taskUserStatus);
  const taskUserStatusColor = { backgroundColor: taskUserStatusValues?.color };

  return (
    <div className={classes.headerContainer}>
      <div className={classes.headerSection}>
        <UserThumbnail image={user?.profileImage} alt={userName} />
        <div className={classes.titleContainer}>
          <div className={classes.headerTitle}>{userName}</div>
          {!isNilOrEmpty(taskUserStatus) && (
            <div className={classes.headerStatus} style={taskUserStatusColor}>
              {taskUserStatusValues.text}
            </div>
          )}
          <div className={classes.headerSubtext}>{user?.email}</div>
        </div>
      </div>
      <div>
        <IconButton onClick={() => setIsLeadAssignee(!isLeadAssignee)}>
          {isLeadAssignee ? (
            <Icon color={colors.brand.blue}>star</Icon>
          ) : (
            <Icon>star_border</Icon>
          )}
        </IconButton>
        <Link to={`/team/${user?.userId}`}>
          <IconButton>
            <Icon>launch</Icon>
          </IconButton>
        </Link>
      </div>
    </div>
  );
};

export default ModalTitle;
